import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'Actions';
import Modal from 'Utils/Modal';
import { DeleteCircle } from 'Utils/SvgIcons';
import Checkbox from 'Utils/Checkbox';
import { capitalizeFirstLetter } from 'HelperFunctions/general';
import originalTerminologies from '../../helper_functions/originalTerminologies';

const plurals = {
  item: 'items',
  accessory: 'accessories',
  purchase: 'addons',
  bundle: 'bundles',
};

class DeleteMultilocationProduct extends Component {
  state = {
    open: false,
    checks: [false, false],
  };

  toggleDialog = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleDelete = () => {
    const allMarked = this.validate();
    if (allMarked) {
      const { type, deleteProduct } = this.props;
      deleteProduct(this.props.id, plurals[type]);
    } else {
      this.props.setErrors('Must check all checkboxes before you can submit.');
    }
  };

  handleCheckbox = (index, isChecked) => {
    let newChecks = [...this.state.checks];
    newChecks[index] = isChecked;

    this.setState({ checks: newChecks });
  };

  validate = () => {
    const { checks } = this.state;

    let allMarked = true;

    for (let check of checks) {
      if (!check) {
        allMarked = false;
        break;
      }
    }

    return allMarked;
  };

  render() {
    const { type } = this.props;
    const { checks, open } = this.state;

    const checkLabels = [
      'Your inventory numbers and sharing will go down.',
      "Rentals using this item may need to be subrented if there aren't enough for the rental.",
    ];
    const { purchaseSingular } = originalTerminologies();

    return (
      <div className='itemDelete'>
        <a
          id='delete_product'
          className='btnLink delete'
          onClick={this.toggleDialog}
        >
          Delete{' '}
          {type === 'purchase' ? purchaseSingular : capitalizeFirstLetter(type)}
          <DeleteCircle />
        </a>
        <Modal
          open={open}
          toggle={this.toggleDialog}
          className='warn'
          title='Are you sure you want to delete this item?'
          large={true}
          actions={[
            <button
              id='confirm_delete'
              className='btn warn'
              onClick={this.handleDelete}
            >
              Yes, Delete This Item
            </button>,
            <button className='btn cancel' onClick={this.toggleDialog}>
              Cancel
            </button>,
          ]}
        >
          <div>
            <p>Are you sure you want to delete this item?</p>
            <p>It will lessen the amount rentable across all locations.</p>
            <div>
              {checkLabels.map((check, index) => (
                <Checkbox
                  key={index}
                  checked={checks[index]}
                  label={check}
                  onCheck={(event, isChecked) =>
                    this.handleCheckbox(index, isChecked)
                  }
                />
              ))}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect(null, actions)(DeleteMultilocationProduct);
